import type {Poster} from '@PosterWhiteboard/poster/poster.class';
import {ElementDataType} from '@Libraries/add-media-library';
import {ImageItemSource} from '@Libraries/image-item.library';
import {getUrlForGeneratedAiChatModelAssetsImage} from '@Libraries/ai-chat.library';
import {MediaItemSizeType} from '@Libraries/s3-library';
import {loadImageAsync} from '@Utils/image.util';
import {getContainCenteredPlacement} from '@Utils/math.util';
import {getUniqueId} from '@Utils/string.util';
import {hideLoading, showLoading} from '@Libraries/loading-toast-library';
import {LoadingVariant} from '@Components/loading-toast';

const ADD_AI_CHAT_IMAGE_LOADING_KEY = 'addAiChatImageToEditor';

export const addAiChatImageToEditor = async (poster: Poster, aiChatImageAssetHashedId: string): Promise<void> => {
  window.history.replaceState(null, '', window.PMW.util.site_url(`posterbuilder/load/${poster.hashedID}`));

  const pageId = poster.pages.pageOrder[0];
  const page = pageId ? poster.pages.getPage(pageId) : undefined;
  if (!page || Object.keys(page.items.itemsHashMap).length > 0) {
    return;
  }

  showLoading(ADD_AI_CHAT_IMAGE_LOADING_KEY, {text: window.i18next.t('pmwjs_preparing_editor'), variant: LoadingVariant.AI});

  try {
    const assetUrl = getUrlForGeneratedAiChatModelAssetsImage(aiChatImageAssetHashedId, MediaItemSizeType.HIGH_RES);
    const image = await loadImageAsync(assetUrl);
    const placement = getContainCenteredPlacement(page.poster.width, page.poster.height, image.naturalWidth, image.naturalHeight);

    await page.items.addItems.addNewItems(
      [
        {
          type: ElementDataType.IMAGE,
          source: ImageItemSource.UPLOAD,
          uid: getUniqueId(),
          dataUrl: assetUrl,
          aiChatImageAssetHashedId,
          ...placement,
        },
      ],
      {selectOnAdd: false}
    );
  } finally {
    hideLoading(ADD_AI_CHAT_IMAGE_LOADING_KEY);
  }
};
